import { render } from "./StepA.vue?vue&type=template&id=1a179152"
import script from "./StepA.vue?vue&type=script&lang=js"
export * from "./StepA.vue?vue&type=script&lang=js"

import "./StepA.vue?vue&type=style&index=0&id=1a179152&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/signupLawyer/StepA.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1a179152"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1a179152', __exports__)) {
    api.reload('1a179152', __exports__)
  }
  
  module.hot.accept("./StepA.vue?vue&type=template&id=1a179152", () => {
    api.rerender('1a179152', render)
  })

}


export default __exports__